import React from "react"

import PricePage from "../../components/CatalogSaj/PricePage"
import { sajCars } from "../../components/CatalogSaj/data"

const KatalizatorPage = () => <PricePage data={sajCars[0]} />

export default KatalizatorPage
